import { useEffect, useState } from "react";

const cache: Record<string, any> = {};

const useEntityQuery = (
  key: string,
  fetcher: () => Promise<any>,
  enabled: boolean,
) => {
  const [data, setData] = useState<any[]>(cache[key] || []);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return;

    // already cached
    if (cache[key]) {
      setData(cache[key]);
      return;
    }

    let mounted = true;

    const load = async () => {
      try {
        setLoading(true);
        const result = await fetcher();

        cache[key] = result;

        if (mounted) {
          setData(result);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching entity:", error);
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      mounted = false;
    };
  }, [key, enabled, fetcher]);

  return { data, loading };
};

export default useEntityQuery;
